import React, { useState } from 'react'
import ReactModal from 'react-modal'
import '../../styles/modals/DayReflectionModal.css'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'
import { ReactComponent as SecretKeyLogo } from '../../svg/normalSvgs/SecretKeyLogo.svg'
import { useTranslation } from 'react-i18next'
import { useToasts } from 'react-toast-notifications'
import { notify } from '../../utils/util'

function NewSecretKeyModal({ modalIsOpen, closeModal, elementId }) {
    const [secretKey, setSecretKey] = useState('')
    const { t } = useTranslation()
    const { addToast } = useToasts()
    const [secretKeyError, setSecretKeyError] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()

        setSecretKeyError('')

        if (!secretKey.trim()) {
            setSecretKeyError(t('required'))
            return
        }

        addToast(t('secretKeyHasBeenSaved'), {
            appearance: 'success',
            autoDismiss: true,
        })

        localStorage.setItem('secret_key', secretKey)

        setSecretKey('')

        closeModal()
    }

    React.useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById(elementId).style.filter = 'blur(5px)'
        } else {
            document.getElementById(elementId).style.filter = 'unset'
        }
    }, [modalIsOpen])
    return (
        <ReactModal
            transparent
            isOpen={modalIsOpen}
            ariaHideApp={false}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 5,
                },
                content: {
                    inset: 0,
                    padding: 0,
                    margin: 0,
                    marginTop: 30,
                    opacity: 1,
                    width: 490,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '90%',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                },
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="day-reflection-modal-icon" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
            </div>
            <div className="new-secret-key">
                <SecretKeyLogo />
                <p className="new-secret-title">{t('Stay Secure')}</p>
                <p className="new-secret-subtitle">
                    <b>{t('Attention')}</b>: {t('toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey')}
                </p>
                <form style={{ width: '100%' }}>
                    <p className="new-secret-key-label">{t('secretKey')}</p>
                    <input
                        className="new-secret-key-input"
                        type="password"
                        placeholder={t('Enter your secret key')}
                        value={secretKey}
                        onChange={(e) => {
                            setSecretKey(e.target.value)
                            if (secretKeyError) setSecretKeyError('')
                        }}
                        autoComplete="off"
                    />

                    <span className="input-error-text">{secretKeyError}</span>
                </form>
                <button className="new-secret-save-button" onClick={handleSubmit}>
                    <p className="new-secret-save-text">{t('save')}</p>
                </button>
            </div>
        </ReactModal>
    )
}

export default NewSecretKeyModal
